module.exports = __webpack_public_path__ + "img/75642.09284304.svg";